import React from 'react';

const Footer = () => {
    return (
        <div className="col-sm-12 col-md-12 text-center p-3">
            Copyright ©{(new Date().getFullYear())} <strong>Habibullah Asif</strong>
        </div>
    );
};

export default Footer;
